<!-- 引导修改默认密码 -->

<style lang="less">
.guide--change-pwd {
  .el-dialog {
    border-radius: 4px;
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .pic {
    display: table;
    margin: auto;
    width: 110px;
  }
  .tip {
    color: #333;
  }
  .pic ~ .tip {
    margin-top: 30px;
  }
  .tip ~ .el-button {
    margin-top: 45px;
  }
}
</style>

<template>
  <el-dialog
    class="guide--change-pwd"
    :visible.sync="visible"
    width="400px"
    :before-close="handleClose"
  >
    <div class="text-center">
      <img class="pic" src="../assets/images/reset_password.png" />
      <p class="tip">{{tip}}</p>
      <el-button type="primary" @click="handleChange">立即设置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'GuideChangePWD',
  computed: {
    ...mapGetters(['user']),
    tip() {
      if (this.user.default_pwd) {
        return '请前往设置登录密码'
      }
      if (this.user.invalid_pwd) {
        return '您的密码已过期，请重置密码'
      }
      return '为了您的账号安全，请重置密码'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.handleOpen()
    }, 3e3);
  },
  methods: {
    // 判断是否需要展示
    handleOpen() {
      // 不可在 账号设置 页面
      if (this.$route.name === 'PersonalConfig') {
        return
      }

      // 不是默认密码 不用提醒
      if (!this.user.default_pwd && !this.user.invalid_pwd) {
        return
      }

      // 本次会话不再提醒
      if (sessionStorage.getItem('change_pwd')) {
        return
      }

      this.visible = true
    },
    handleClose() {
      this.visible = false
      sessionStorage.setItem('change_pwd', 'no')
    },
    handleChange() {
      this.handleClose()
      setTimeout(() => {
        this.$router.push({
          name: 'PersonalConfig'
        })
      }, 3e2)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/guide-change-pwd.vue